import { FC } from 'react';

import { useGetUser } from 'app/api/hooks/core/v1/auth/user';
import { useCanViewPaperwork } from 'app/api/hooks/paperwork/v1/bills';
import AppLayout, { LayoutProps, Link } from 'app/components/layout/AppLayout';
import { payeeRoutes, routes } from 'app/constants/routes';
import { useQueryString } from 'app/state/NavigationContext/hooks';
import { isPayeeAdmin, isPayeeAndOnlyDriver, isPayeeBilling } from 'app/utils/lib/user';

// Component Definition
const PayeeRoutesLayout: FC<LayoutProps> = props => {
  const invoicesQueryString = useQueryString('payeeInvoices');
  const paymentsQueryString = useQueryString('payeePayments');
  const billsQueryString = useQueryString('payeePaperwork');

  const user = useGetUser();
  const canUserViewPaperwork = useCanViewPaperwork();

  const isAdminOrBilling = isPayeeAdmin(user) || isPayeeBilling(user);
  const isDriver = isPayeeAndOnlyDriver(user);
  const logoPath = isDriver
    ? `/${routes.payee}/${payeeRoutes.paperwork}${billsQueryString}`
    : `/${routes.payee}/${payeeRoutes.dashboard}`;

  const paperworkLink: Link = {
    activePaths: [`/${routes.payee}/${payeeRoutes.paperwork}`],
    iconName: 'receipt',
    id: 'paperwork',
    label: 'Paperwork',
    to: `/${routes.payee}/${payeeRoutes.paperwork}${billsQueryString}`,
  };

  const sharedLinks: Link[] = [
    {
      activePaths: [`/${routes.payee}/${payeeRoutes.invoices}`],
      iconName: 'file',
      id: 'invoices',
      label: 'Invoices',
      to: `/${routes.payee}/${payeeRoutes.invoices}${invoicesQueryString}`,
    },
    {
      activePaths: [`/${routes.payee}/${payeeRoutes.payments}`],
      iconName: 'money',
      id: 'payments',
      label: 'Payments',
      to: `/${routes.payee}/${payeeRoutes.payments}${paymentsQueryString}`,
    },
  ];

  const driverLinks: Link[] = [];

  if (canUserViewPaperwork) {
    driverLinks.unshift(paperworkLink);
    sharedLinks.unshift(paperworkLink);

    sharedLinks.unshift({
      activePaths: [`/${routes.payee}/${payeeRoutes.dashboard}`],
      iconName: 'home',
      id: 'dashboard',
      label: 'Dashboard',
      to: `/${routes.payee}/${payeeRoutes.dashboard}`,
    });
  }

  const adminBillingLinks: Link[] = isAdminOrBilling ? sharedLinks : [];
  const links: Link[] = isDriver ? driverLinks : adminBillingLinks;

  return (
    <AppLayout
      body={props.body}
      logoPath={logoPath}
      navLinks={links}
    />
  );
};

export default PayeeRoutesLayout;
